var Handlebars = require("/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"open disabled drawer-container\">\n    <div class=\"drawer-body\"></div>\n    <div class=\"drawer-pull\">\n        <div class=\"drawer-tab\">\n            <a class=\"btn btn-drawer-pull\">\n                <span class=\"glyphicon glyphicon-search\"></span>\n                <span class=\"glyphicon glyphicon-chevron-down\"></span>\n            </a>\n        </div>\n    </div>\n</div>\n<div class=\"drawer-content\"></div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/lib/common/drawer/templates/layout.hbs
// module id = 1026
// module chunks = 0